import Vue from 'vue';
import appconst from './appconst';
import * as moment from 'moment';
import AbpBase from './abpbase';
import Address from "@/store/entities/address";
import _ from 'lodash'
class Util {
	abp: any = window.abp;
	abpBase: AbpBase = new AbpBase();
	loadScript(url: string) {
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = url;
		document.body.appendChild(script);
	}
	title(title: string) {
		let appname = this.abp.localization.localize('AppName', appconst.localization.defaultLocalizationSourceName);
		let page = this.abp.localization.localize(title, appconst.localization.defaultLocalizationSourceName);
		window.document.title = page + ' - ' + appname;
	}
	inOf(arr: Array<any>, targetArr: any) {
		let res = true;
		arr.forEach(item => {
			if (targetArr.indexOf(item) < 0) {
				res = false;
			}
		});
		return res;
	}
	oneOf(ele: any, targetArr: Array<any>) {
		if (targetArr.indexOf(ele) >= 0) {
			return true;
		} else {
			return false;
		}
	}
	showThisRoute(itAccess: any, currentAccess: any) {
		if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
			return this.oneOf(currentAccess, itAccess);
		} else {
			return itAccess === currentAccess;
		}
	}
	getRouterObjByName(routers: Array<any>, name?: string): any {
		if (!name || !routers || !routers.length) {
			return null;
		}
		// debugger;
		let routerObj = null;
		for (let item of routers) {
			if (item.name === name) {
				return item;
			}
			routerObj = this.getRouterObjByName(item.children, name);
			if (routerObj) {
				return routerObj;
			}
		}
		return null;
	}
	toDefaultPage(routers: Array<any>, name: string | undefined, route: any, next: any) {
		let len = routers.length;
		let i = 0;
		let notHandle = true;
		while (i < len) {
			if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
				route.replace({
					name: routers[i].children[0].name,
				});
				notHandle = false;
				next();
				break;
			}
			i++;
		}
		if (notHandle) {
			next();
		}
	}
	handleTitle(vm: any, item: any) {
		if (typeof item.meta.title === 'object') {
			return vm.$t(item.title.i18n);
		} else {
			return item.meta.title;
		}
	}
	setCurrentPath(vm: Vue, name?: string) {
		let title = '';
		let isOtherRouter = false;
		vm.$store.state.app.routers.forEach((item: any) => {
			if (item.children.length === 1) {
				if (item.children[0].name === name) {
					title = this.handleTitle(vm, item);
					if (item.name === 'otherRouter') {
						isOtherRouter = true;
					}
				}
			} else {
				item.children.forEach((child: any) => {
					if (child.name === name) {
						title = this.handleTitle(vm, child);
						if (item.name === 'otherRouter') {
							isOtherRouter = true;
						}
					}
				});
			}
		});

		let dashboardPath = {
			meta: { title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.app.routers, 'dashboard')) },
			path: 'fdashboard/dashboard',
			name: 'dashboard',
		};
		let currentPathArr = [dashboardPath];
		if (name !== 'dashboard') {
			if ((name as string).indexOf('index') >= 0 || isOtherRouter) {
				currentPathArr.push({
					meta: { title: title },
					path: '',
					name: name,
				});
			} else {
				let currentPathObj = this.getCurrentObjFunction(vm, name);
				if (currentPathObj !== undefined && currentPathObj !== null && currentPathObj.name !== 'dashboard') {
					currentPathArr = this.getCurrentPathArrFunction(currentPathObj, name, currentPathArr as [any]);
				}
			}
		}
		vm.$store.commit('app/setCurrentPath', currentPathArr);
		return currentPathArr;
	}
	getCurrentObjFunction(vm: Vue, name: string) {
		let currentPathObj = vm.$store.state.app.routers.filter((item: any) => {
			if (item.name === name) return true;
			if (item.children && item.children.length > 0) {
				let i = 0;
				let childArr = item.children;
				let len = childArr.length;
				while (i < len) {
					if (childArr[i].name === name) {
						return true;
					}
					if (childArr[i].children && childArr[i].children.length > 0) {
						let j = 0;
						let subArr = childArr[i].children;
						let sublen = subArr.length;
						while (j < sublen) {
							if (subArr[j].name === name) {
								return true;
							}
							j++;
						}
					}
					i++;
				}
				return false;
			}
		})[0];
		return currentPathObj;
	}
	getCurrentPathArrFunction(item: any, name: string, currentPathArr: [any]) {
		currentPathArr.push({
			meta: { title: item.meta.title },
			path: item.path,
			name: item.name,
		});
		if (item.name !== name && item.children && item.children.length && item.children.length > 0) {
			let i = 0;
			let childArr = item.children;
			let len = childArr.length;
			while (i < len) {
				if (childArr[i].name && childArr[i].name === name) {
					currentPathArr.push({
						meta: { title: childArr[i].meta.title },
						path: item.path + '/' + childArr[i].path,
						name: childArr[i].name,
					});
				} else {
					if (childArr[i].children && childArr[i].children.length && childArr[i].children.length > 0) {
						let j = 0;
						let subchildArr = childArr[i].children;
						let sublen = subchildArr.length;
						while (j < sublen) {
							if (subchildArr[j].name && subchildArr[j].name === name) {
								currentPathArr.push({
									meta: { title: childArr[i].meta.title },
									path: item.path + '/' + childArr[i].path,
									name: childArr[i].name,
								});
								currentPathArr.push({
									meta: { title: subchildArr[j].meta.title },
									path: item.path + '/' + childArr[i].path + '/' + subchildArr[j].path,
									name: name,
								});
							}
							j++;
						}
					}
				}
				i++;
			}
		}
		return currentPathArr;
	}
	openNewPage(vm: Vue, name: string | undefined, argu?: any, query?: any) {
		let pageOpenedList = vm.$store.state.app.pageOpenedList;
		let openedPageLen = pageOpenedList.length;
		let i = 0;
		let tagHasOpened = false;
		while (i < openedPageLen) {
			if (name === pageOpenedList[i].name) {
				// 页面已经打开
				vm.$store.commit('app/pageOpenedList', {
					index: i,
					argu: argu,
					query: query,
				});
				tagHasOpened = true;
				break;
			}
			i++;
		}
		if (!tagHasOpened) {
			let tag = vm.$store.state.app.tagsList.filter((item: any) => {
				if (item.children && item.children.length > 0) {
					return name === item.children[0].name;
				} else {
					return name === item.name;
				}
			});
			tag = tag[0];
			if (tag) {
				tag = tag.children ? tag.children[0] : tag;
				if (argu) {
					tag.argu = argu;
				}
				if (query) {
					tag.query = query;
				}
				vm.$store.commit('app/increateTag', tag);
			}
		}
		vm.$store.commit('app/setCurrentPageName', name);
	}
	fullscreenEvent(vm: Vue) {
		vm.$store.commit('app/initCachepage');
		// 权限菜单过滤相关
		vm.$store.commit('app/updateMenulist');
		// 全屏相关
	}
	extend(...args: any[]) {
		let options,
			name,
			src,
			srcType,
			copy,
			copyType,
			copyIsArray,
			clone,
			target = args[0] || {},
			i = 1,
			length = args.length,
			deep = false;
		if (typeof target === 'boolean') {
			deep = target;
			target = args[i] || {};
			i++;
		}
		if (typeof target !== 'object' && typeof target !== 'function') {
			target = {};
		}
		if (i === length) {
			target = this;
			i--;
		}
		for (; i < length; i++) {
			if ((options = args[i]) !== null) {
				for (name in options) {
					src = target[name];
					copy = options[name];
					if (target === copy) {
						continue;
					}
					srcType = Array.isArray(src) ? 'array' : typeof src;
					if (deep && copy && ((copyIsArray = Array.isArray(copy)) || typeof copy === 'object')) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && srcType === 'array' ? src : [];
						} else {
							clone = src && srcType === 'object' ? src : {};
						}
						target[name] = this.extend(deep, clone, copy);
					} else if (copy !== undefined) {
						target[name] = copy;
					}
				}
			}
		}
		return target;
	}
	isSerial(storagetype: string) {
		var isSerial = new RegExp('^' + appconst.storageType.serial, 'i').test(storagetype);
		return isSerial;
	}
	trimWhiteSpace(value: string) {
		return value.replace(/\s/g, '');
	}
	isNull(value: any) {
		return value === undefined || value === null || value === NaN;
	}
	isEmpty(value: string) {
		return this.isNull(value) || this.trimWhiteSpace(value) === '';
	}
	toViewShortTimeDateString(value: any) {
		return moment
			.utc(String(value))
			.local()
			.format(appconst.viewShortTimeDateFormat);
	}
	toViewTimeDateString(value: any) {
		return moment
			.utc(String(value))
			.local()
			.format(appconst.viewTimeDateFormat);
	}
	toViewDateString(value: any) {
		return moment
			.utc(String(value))
			.local()
			.format(appconst.viewDateFormat);
	}
	toLocalViewDateString(value: any) {
		return moment.utc(String(value)).format(appconst.viewDateFormat);
	}
	toReportOriginDateString(value: any) {
		return moment
			.utc(String(value))
			.format(appconst.reportDateFormat);
	}
	toReportDateString(value: any) {
		return moment
			.utc(String(value))
			.local()
			.format(appconst.reportDateFormat);
	}
	toMonthYearString(value: any) {
		return moment
			.utc(String(value))
			.local()
			.format(appconst.monthYearFormat);
	}
	toViewNumberString(value: number) {
		if(_.isNil(value))
			return '';
		return Number(value).toLocaleString(appconst.viewNumberFormat);
	}
	formatLocateNumber = (value: any, maximumFractionDigits = 0, allowEmpty = false) => {
		if (_.isNil(value) && allowEmpty) {
		  return '';
		}
		const formatval = Intl.NumberFormat('en-US', {
		  minimumFractionDigits: 0,
		  maximumFractionDigits: maximumFractionDigits,
		}).format(value || 0);
		return _.isNaN(formatval) ? '1' : formatval;
	  };
	toViewDatePickerString(value: Date) {
		return moment
			.utc(String(value))
			.local()
			.format(appconst.datePickerFormatString);
	}
	toBacklogDateString(value: Date) {
		return moment(String(value)).format(appconst.backlogDateFormat);
	}
	hasUnicode(value: string) {
		return new RegExp(appconst.unicodeRegexPattern).test(value);
	}
	getWarningTitle() {
		return this.abpBase.L('Warning');
	}
	getConfirmTitle() {
		return this.abpBase.L('Confirm');
	}
	getErrorTitle() {
		return this.abpBase.L('Error');
	}
	getYesText() {
		return this.abpBase.L('Yes');
	}
	getNoText() {
		return this.abpBase.L('No');
	}
	getMsgFromResource(key: string) {
		return this.abpBase.L(key);
	}
	pagingItems(list: Array<any>, pageSize: number, currentPage: number) {
		if (this.isNull(list) || list.length <= 0) return new Array<any>();

		var len = pageSize;
		var range = (currentPage - 1) * len;
		var resultList = new Array<any>();
		for (var i = 0; i < list.length && i < len; i++) {
			var item = list[i + range];
			if (item === undefined || item === null) break;
			resultList.push(item);
		}
		return resultList;
	}
	getUrlImage(imageName: string) {
		if (this.isNull(imageName) || this.isEmpty(imageName)) return `${appconst.remoteServiceBaseUrl}api/services/app/file?path=default-product.jpeg`;
		return `${appconst.remoteServiceBaseUrl}api/services/app/file?path=${imageName}`;
	}
	getAppUrlImage(imageName: string) {
		if (this.isNull(imageName) || this.isEmpty(imageName)) return `${appconst.remoteServiceBaseUrl}api/services/app/file?path=default-product.jpeg`;
		return `${appconst.remoteServiceBaseUrl}api/services/app/file?path=${imageName}`;
	}
	showWarningMsg(vm: Vue, msg: string) {
		vm.$Modal.warning({
			title: this.getWarningTitle(),
			content: msg,
			okText: this.getYesText(),
		});
	}
	showSuccessMsg(vm: Vue, msg: string) {
		vm.$Modal.success({
			title: this.getConfirmTitle(),
			content: this.abpBase.L(msg),
			okText: this.getYesText(),
		});
	}
	showSuccessMsgCallback(vm: Vue, msg: string, callback : any) {
		vm.$Modal.success({
			title: this.getConfirmTitle(),
			content: this.abpBase.L(msg),
			okText: this.getYesText(),
			onOk: () => {
				callback();
			  },
		});
	}
	showErrorMsg(vm: Vue, msg: string) {
		vm.$Modal.error({
			title: this.L('ErrorTitle'),
			content: this.abpBase.L(msg),
			okText: this.getYesText(),
		});
	}
	showErrorArgusMsg(vm: Vue, msg: string, ...argus: string[]) {
		vm.$Modal.error({
			title: this.L('ErrorTitle'),
			content: this.abpBase.L(msg, ...argus),
			okText: this.getYesText(),
		});
	}

	showNoticeErrorMsg(vm: Vue, msg: string) {
		vm.$Notice.error({
			title: this.L('ErrorTitle'),
			desc: msg,
		});
	}

	getIsImportedIcon(isImported: boolean) {
		return isImported ? 'md-checkmark-circle' : 'md-close-circle';
	}
	L(value: string, source?: string, ...argus: string[]): string {
		return this.abpBase.L(value, source, ...argus);
	}
	renderErrorMsgElements(errorMsg: string) {
		var errorHlmlString = '';
		if (!this.isEmpty(errorMsg)) {
			var errorObj = JSON.parse(errorMsg);
			if (errorObj == null || errorObj.length <= 0) return '';

			for (var i = 0; i < errorObj.length; i++) {
				errorHlmlString = errorHlmlString.concat(
					'<span>' + errorObj[i].Property + ' : ' + errorObj[i].Data + '</span><br/>'
				);
			}
		}
		return errorHlmlString;
	}
	renderImportErrorMsgElements(errorMsg: string) {
		var errorHlmlString = '';
		if (!this.isEmpty(errorMsg)) {
			if (errorMsg.endsWith('/')) errorMsg = errorMsg.slice(0, errorMsg.length - 1);
			var errorObj = errorMsg.split('/');
			if (errorObj == null || errorObj.length <= 0) return '';

			for (var i = 0; i < errorObj.length; i++) {
				errorHlmlString = errorHlmlString.concat('<span>' + errorObj[i] + '.</span><br/>');
			}
		}
		return errorHlmlString;
	}
	onlyUnique(value, index, self) {
		return self.indexOf(value) === index;
	}
	indexWhere(array: Array<any>, conditionFn) {
		const item = array.find(conditionFn);
		return array.indexOf(item);
	}
		buildDefaultViewDate(rangeDays: number) {
			var toMoment = moment();
			var fromMoment = moment().subtract(rangeDays, 'd');
			var toDate = new Date(toMoment.format(appconst.reportDateFormat));
			var fromDate = new Date(fromMoment.format(appconst.reportDateFormat));
			return [fromDate, toDate];
		}
		buildAddress(parts: Array<any>) {
			return parts
				.filter(item => !_.isNil(item) && !_.isEmpty(String(item).trim()))
				.map(item => String(item).trim())
				.join(', ');
		}
		addressDiff(oldAddress: Address, newAddress : Address)
		{
			return _.get(oldAddress, 'addressNo') != _.get(newAddress, 'addressNo')
				|| _.get(oldAddress, 'districtId') != _.get(newAddress, 'districtId')
				|| _.get(oldAddress, 'wardId') != _.get(newAddress, 'wardId');
		}
		isProductSkuFormat(value: string) {
			return new RegExp(appconst.productSkuRegexPattern).test(value);
		}
	}
const util = new Util();
export default util;
